import { Alert, Button, Group, Stack, Text } from '@mantine/core'
import { statusLabel, ticketPathSegmentFromListItem, ticketPublicId } from '@/lib/ticket-display'
import type { ParallelCustomerTicketItem, ParallelCustomerTicketsResponse } from '@/types/api'

type Props = {
  data: ParallelCustomerTicketsResponse
  onGoToEarliest: (ticket: ParallelCustomerTicketItem) => void
  onDismiss: () => void
}

export function ParallelCustomerTicketsBanner({ data, onGoToEarliest, onDismiss }: Props) {
  const earliest = data.earliest
  if (!earliest || !data.tickets.length) return null

  const hot = data.severity === 'hot'
  const color = hot ? 'red' : 'orange'
  const publicId = ticketPublicId(earliest.project_slug, earliest.ticket_number)
  const where = [earliest.project_name, earliest.channel_name].filter(Boolean).join(' · ')
  const extra = data.tickets.length > 1 ? ` (ещё ${data.tickets.length - 1})` : ''

  return (
    <Alert
      color={color}
      variant="filled"
      radius="md"
      p="md"
      title={hot ? 'У клиента уже есть открытое обращение' : 'У клиента есть другое активное обращение'}
      withCloseButton
      onClose={onDismiss}
      styles={{
        root: { alignItems: 'flex-start' },
        title: {
          marginBottom: 6,
          fontSize: 'var(--mantine-font-size-lg)',
          fontWeight: 800,
          lineHeight: 1.25,
          color: 'var(--mantine-color-white)',
        },
        message: { width: '100%' },
        closeButton: { color: 'var(--mantine-color-white)' },
      }}
    >
      <Stack gap="sm">
        <Text size="md" c="var(--mantine-color-white)" lh={1.45} style={{ opacity: 0.95 }}>
          Самое раннее: {publicId}
          {where ? ` — ${where}` : ''}
          {` (${statusLabel(earliest.status)})`}
          {extra}. Продолжите диалог там и закройте текущее обращение вручную.
        </Text>
        <Group justify="flex-end" wrap="wrap" gap="xs">
          <Button
            variant="white"
            color={color}
            size="sm"
            fw={600}
            onClick={() => onGoToEarliest(earliest)}
          >
            Перейти к {ticketPathSegmentFromListItem(earliest)}
          </Button>
        </Group>
      </Stack>
    </Alert>
  )
}
